import { ACTIONS } from '../Constants';

const initialState = {
    isMobile: false
};

const mobile = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.SET_MOBILE_STATUS: {
            const newState = Object.assign({}, state);
            newState.isMobile = action.payload.isMobile;
            return newState;
        }
        default:
            return state;
    }
};

export default mobile;
